"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteCustomClaimSaga = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var deleteCustomClaimApi_1 = require("../../../apis/delete/deleteCustomClaimApi");
var createDeleteCustomClaimSuccessAction_1 = require("../../../actionCreators/delete/DeleteCustomClaim/createDeleteCustomClaimSuccessAction");
var createDeleteCustomClaimFailureAction_1 = require("../../../actionCreators/delete/DeleteCustomClaim/createDeleteCustomClaimFailureAction");
var createDeleteCustomClaimRequestAction_1 = require("../../../actionCreators/delete/DeleteCustomClaim/createDeleteCustomClaimRequestAction");
var createErrorAction_1 = require("../../../actionCreators/createErrorAction");
var deleteCustomClaimSaga = function (_a) {
    var error_1;
    var apiHeaders = _a.apiHeaders;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)((0, createDeleteCustomClaimRequestAction_1.createDeleteCustomClaimRequestAction)({
                    description: 'deleteCustomClaimSaga',
                    requestValues: {},
                }))];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                _b.trys.push([2, 5, , 8]);
                return [4 /*yield*/, (0, deleteCustomClaimApi_1.deleteCustomClaimApi)({
                        apiHeaders: apiHeaders,
                    })];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createDeleteCustomClaimSuccessAction_1.createDeleteCustomClaimSuccessAction)({
                        description: 'deleteCustomClaimSaga',
                    }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 8];
            case 5:
                error_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                        error: error_1,
                        description: 'deleteCustomClaimSaga',
                    }))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, createDeleteCustomClaimFailureAction_1.createDeleteCustomClaimFailureAction)({
                        description: 'deleteCustomClaimSaga',
                    }))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
};
exports.deleteCustomClaimSaga = deleteCustomClaimSaga;
